import { isString } from "lodash";

export default s =>
  isString(s)
    ? s.endsWith(".0000")
      ? s.substr(0, s.length - 5)
      : s.endsWith(".00000")
        ? s.substr(0, s.length - 6)
        : s
    : s;
